import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'Overview',
      href: '/en/Outdoor_Cameras/IN-4011/',
    },
    {
      text: 'Specifications',
      href: '/en/Outdoor_Cameras/IN-4011/Technical_Specifications/',
    },
    {
      text: 'Usermanual',
      href: '/en/Outdoor_Cameras/IN-4011/Usermanual/',
    },
    {
      text: '◄ Outdoor Cameras',
      href: '/en/Outdoor_Cameras/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        aria-label="INSTAR IN-4011 Online Usermanual Chapters"
      />
      <EuiSpacer />
    </Fragment>
  );
}